/**
 * TaskBadgeAndName.js
 * Created by calhosh on 1/17/2020.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {currentResource} from '../../../util/utils';
import styled from 'styled-components';
import Utility from '../../../util/utilityfunctions';
import TaskInfoRow from '@ey/canvascoreservices/TaskBadgeAndName';
import {useDocumentId} from '../../../util/customHooks';

export default function TaskBadgeAndName(props) {
	const {
		taskId,
		taskTypeId,
		taskName,
		taskVersionNumber,
		isEpEqr,
		linesBeforeEllipse,
		badgeOnNewLine,
		includePipe,
		noBackground,
		isEp,
		isEq,
		hideTaskName,
		noBorderPadding,
		engagement,
		showLink,
		className,
		taskClassName,
		viewType,
		linkNewWindow = false,
		isEllipsed = true,
		customContent,
		hideTooltip,
		onClick
	} = props;

	const documentId = useDocumentId();
	// Builds a link to the current task's details page
	const buildTaskDetailsUrl = () => {
		let taskDetailsUrl;

		if (showLink) {
			taskDetailsUrl = Utility.getTaskUrl(
				taskId,
				taskTypeId,
				engagement,
				taskVersionNumber,
				undefined,
				undefined,
				undefined,
				documentId
			);
		}
		return taskDetailsUrl;
	};

	return (
		<StyledTaskInfoRow
			taskId={taskId}
			taskTypeId={taskTypeId}
			taskName={taskName}
			isEpEqr={isEpEqr}
			linesBeforeEllipse={linesBeforeEllipse}
			badgeOnNewLine={badgeOnNewLine}
			includePipe={includePipe}
			noBackground={noBackground}
			isEp={isEp}
			isEq={isEq}
			hideTaskName={hideTaskName}
			noBorderPadding={noBorderPadding}
			link={buildTaskDetailsUrl()}
			className={className}
			taskClassName={taskClassName}
			viewType={viewType}
			customContent={customContent}
			linkNewWindow={linkNewWindow}
			hideTooltip={hideTooltip}
			taskTypeBadges={currentResource.taskTypeBadge}
			isEllipsed={isEllipsed}
			onClick={onClick}
		/>
	);
}

TaskBadgeAndName.propTypes = {
	taskId: PropTypes.string.isRequired,
	taskTypeId: PropTypes.number.isRequired,
	taskName: PropTypes.string.isRequired,
	taskVersionNumber: PropTypes.number.isRequired,
	isEpEqr: PropTypes.bool,
	linesBeforeEllipse: PropTypes.number,
	badgeOnNewLine: PropTypes.bool,
	includePipe: PropTypes.bool,
	noBackground: PropTypes.bool,
	isEp: PropTypes.bool,
	isEq: PropTypes.bool,
	hideTaskName: PropTypes.bool,
	noBorderPadding: PropTypes.bool,
	engagement: PropTypes.shape({}),
	showLink: PropTypes.bool,
	className: PropTypes.string,
	taskClassName: PropTypes.string,
	viewType: PropTypes.string,
	linkNewWindow: PropTypes.bool,
	isEllipsed: PropTypes.bool,
	customContent: PropTypes.node,
	hideTooltip: PropTypes.bool,
	onClick: PropTypes.func
};

const StyledTaskInfoRow = styled(TaskInfoRow)`
	width: auto;
	max-width: 100%;
	border-bottom: var(--px-1) solid var(--neutrals-200);
	padding: var(--px-10) 0;
	&.includePipe {
		.TaskNames {
			display: inline-block;
			width: auto;
			max-width: 90%;
			border-left: var(--px-1) solid var(--neutrals-900);
			padding-left: var(--px-10);
			a {
				color: var(--blue-600);
			}
		}
	}
	&.badgeOnNewLine {
		.TaskNames {
			display: block;
			width: 100%;
			margin: 0;
		}
	}
	&.noBackground {
		.TaskBadges {
			background-color: transparent;
			color: var(--neutrals-900);
			border: none;
			text-align: left;
		}
		.TaskBadges.Primary {
			background-color: transparent;
			color: var(--neutrals-900);
			border: none;
		}
	}
	&.noBorderPadding {
		padding: 0;
		border: 0;
		.TaskBadges {
			padding: 0;
		}
	}
	&.individualView {
		.TaskBadges {
			min-width: var(--px-10);
			padding-right: var(--px-5);
		}
	}
	&.listView {
		.TaskBadges {
			min-width: var(--px-60);
		}
	}
	.TaskNames {
		display: inline-block;
		width: auto;
		max-width: calc(100% - var(--px-60));
	}
	.TaskBadges {
		display: inline-block;
		text-align: center;
		padding: var(--px-2) var(--px-3);
		margin: 0 var(--px-5) 0 0;
		font-size: var(--px-12);
		font-weight: bold;
		background-color: var(--neutrals-300);
		color: var(--green-400);
		border: var(--px-2) solid var(--neutrals-300);
		&.Primary {
			background-color: var(--green-400);
			color: var(--neutrals-00white);
			border: var(--px-2) solid var(--green-400);
		}
		&.EP {
			background-color: var(--green-400);
			color: var(--neutrals-00white);
			border: var(--px-2) solid var(--green-300);
		}
		&.empty {
			min-height: var(--px-36);
		}
	}
`;
